// client/src/services/authService.js

const apiUrl = process.env.REACT_APP_API_URL || '/api';
const TOKEN_KEY = 'br_auth_token';

const login = async (password) => {
  const response = await fetch(`${apiUrl}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password })
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.message || 'Mot de passe incorrect.');
  localStorage.setItem(TOKEN_KEY, result.token);
  return result;
};

const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
};

const getToken = () => localStorage.getItem(TOKEN_KEY);

// Décode le payload JWT sans dépendance externe et vérifie l'expiration
const isAuthenticated = () => {
  const token = getToken();
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
};

// Appelé par les services quand l'API répond 401 — purge le token et redirige
const handleUnauthorized = () => {
  logout();
  window.location.replace('/login');
};

const authService = { login, logout, getToken, isAuthenticated, handleUnauthorized };

export default authService;
